export const userCardFragment = `
  fragment userCardFragment on UserCardBlockRecord {
    bio
    givenName
    image {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: crop
          h: 160
          q: 45
          w: 160
        }
      ) {
        ...responsiveImageFragment
      }
    }
    jobTitle
    logos {
      responsiveImage(
        imgixParams: {
          auto: format
          fit: clip
          h: 20
          w: 56
          q: 45
        }
      ) {
        ...responsiveImageFragment
      }
    }
    surname
  }
`;
